import { useState, useEffect } from "react";
import { getWastecategoryList } from "../../../services/waste";
import { getClientsList } from "../../../services/client";

/**
 * Hook pour charger les catégories de déchets et les clients
 */
export const useWasteCategoryAndClients = () => {
  const [wasteCategory, setWasteCategory] = useState([]);
  const [corporationClients, setCorporationClients] = useState([]);

  useEffect(() => {
    getWastecategoryList({
      keywordFilter: "",
      listUnCodeFullFilter: {},
      listUnCodeEmptyFilter: {},
      listWasteCodeFullFilter: {},
      listWasteCodeEmptyFilter: {},
      sortByField: "label",
      orderSortByField: "1",
    }).then((response) => {
      setWasteCategory(response.data.data);
    });
    getClientsList().then((response) => {
      if (response.status === 200) {
        setCorporationClients(response.data.data);
      }
    });
  }, []);

  return {
    wasteCategory,
    corporationClients,
  };
};
